import { VisibilityKeys } from 'api/offers-domain/offers-domain.types';

export const withLabelAndId = (subject, label, id) => {
  if (Array.isArray(subject)) {
    return subject.map(object => ({
      ...object,
      label: object[label],
      id: object[id],
    }));
  }
  return { ...subject, label: subject?.[label], id: subject?.[id] };
};

export const getVisibilityTags = (
  subject: any[],
  label: string,
  id: string,
  visibilityKeys?: VisibilityKeys[],
) => {
  let options;
  if (visibilityKeys?.length > 0) {
    options = subject.filter(
      object =>
        !!object?.visibility?.find(visibility =>
          visibilityKeys.includes(visibility),
        ),
    );
  } else {
    options = subject;
  }

  return withLabelAndId(options, label, id);
};
